import './index.css'

const EmploymentTypeItem = props => {
  const {employmentTypeDetails, onSelectTypeOfEmployment} = props
  const {label, employmentTypeId} = employmentTypeDetails
  const onSelectEmployment = () => {
    onSelectTypeOfEmployment(employmentTypeId)
  }
  return (
    <li className="list-item">
      <input
        onChange={onSelectEmployment}
        id={employmentTypeId}
        type="checkbox"
        className="checkbox"
      />
      <label htmlFor={employmentTypeId} className="label">
        {label}
      </label>
    </li>
  )
}

export default EmploymentTypeItem
